import { ORDER_SIDE } from 'shared/consts/filters';

import { EFilterEntity, EFilterFormatter, IFilterSchemeExtended } from '../common';

export const arbitrageTradeHistoryFiltersScheme = (): Record<string, IFilterSchemeExtended> => {
  return {
    range: {
      type: EFilterEntity.date_range,
      label: 'Time range',
      name: 'range',
      field: 'range',
      single: true,
    },
    side: {
      type: EFilterEntity.colors_single_select,
      formatter: EFilterFormatter.colors_single_select,
      label: 'Side',
      name: 'sides',
      field: 'sides',
      listSingleColors: ORDER_SIDE,
      single: true,
    },
    balancer_trades: {
      name: 'balancer_trades',
      type: EFilterEntity.boolean,
      label: 'Balancer trades',
      field: 'balancer_trades',
      formatter: EFilterFormatter.boolean,
      single: true,
    },
    bot_trades: {
      name: 'bot_trades',
      type: EFilterEntity.boolean,
      label: 'Bot trades',
      field: 'bot_trades',
      formatter: EFilterFormatter.boolean,
      single: true,
    },
  };
};
